import { takeEvery } from "redux-saga/effects";

import { initialState, makeReadPayload, generateDefaultActions, requestSaga, fillDictionary } from "../utils/helpers";

export const GET_LOAN_TYPES = generateDefaultActions("GET_LOAN_TYPES");
export const GET_LOAN_SENIORITY_TYPES = generateDefaultActions("GET_LOAN_SENIORITY_TYPES");
export const GET_LOAN_STATUSES = generateDefaultActions("GET_LOAN_STATUSES");
export const GET_LENDERS = generateDefaultActions("GET_LENDERS");
export const GET_BROKERS = generateDefaultActions("GET_BROKERS");
export const GET_SALES_BROKERS = generateDefaultActions("GET_SALES_BROKERS");
export const GET_DEAL_STAGES = generateDefaultActions("GET_DEAL_STAGES");
export const GET_DEAL_STATUSES = generateDefaultActions("GET_DEAL_STATUSES");
export const GET_PREPAYMENT_TYPES = generateDefaultActions("GET_PREPAYMENT_TYPES");
export const GET_FUND_NAMES = generateDefaultActions("GET_FUND_NAMES");
export const GET_USER_COMPANY_CONTACTS = generateDefaultActions("GET_USER_COMPANY_CONTACTS");
export const GET_DEAL_COMPANY_CONTACTS = generateDefaultActions("GET_DEAL_COMPANY_CONTACTS");

export default function enumeratedTypesReducer(state = initialState, action) {
  const { type, payload } = action;
  let key = "";
  let items = [];
  switch (type) {
    case GET_LOAN_TYPES.success:
      key = "loan_types";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_LOAN_SENIORITY_TYPES.success:
      key = "loan_seniority_types";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_LOAN_STATUSES.success:
      key = "loan_statuses";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_LENDERS.success:
      key = "lenders";
      items = fillDictionary(state, payload, "enumeratedTypes", key);

      return items;

    case GET_BROKERS.success:
      key = "brokers";
      items = fillDictionary(state, payload, "enumeratedTypes", key);

      return items;

    case GET_SALES_BROKERS.success:
      key = "sales_brokers";
      items = fillDictionary(state, payload, "enumeratedTypes", key);

      return items;

    case GET_DEAL_STAGES.success:
      key = "deal_stages";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_DEAL_STATUSES.success:
      key = "deal_statuses";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_PREPAYMENT_TYPES.success:
      key = "prepayment_types";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_FUND_NAMES.success:
      key = "fund_names";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_USER_COMPANY_CONTACTS.success:
      key = "user_company_contacts";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    case GET_DEAL_COMPANY_CONTACTS.success:
      key = "deal_company_contacts";
      items = fillDictionary(state, payload, "enumeratedTypes", key);
      localStorage.setItem(key, JSON.stringify(items.enumeratedTypes[key]));

      return items;

    default:
      return state;
  }
}

// GET ConfigItem
export const getLoanTypes = payload => {
  const key = "loan_types";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_LOAN_TYPES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_LOAN_TYPES.value, payload);
};

export const getLoanSeniorityTypes = payload => {
  const key = "loan_seniority_types";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_LOAN_SENIORITY_TYPES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_LOAN_SENIORITY_TYPES.value, payload);
};

export const getloanStatuses = payload => {
  const key = "loan_statuses";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_LOAN_STATUSES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_LOAN_STATUSES.value, payload);
};

export const getLenders = payload => makeReadPayload(GET_LENDERS.value, payload);

export const getBrokers = payload => makeReadPayload(GET_BROKERS.value, payload);

export const getSalesBrokers = payload => makeReadPayload(GET_SALES_BROKERS.value, payload);

export const getDealStages = payload => {
  const key = "deal_stages";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_DEAL_STAGES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_DEAL_STAGES.value, payload);
};

export const getDealStatuses = payload => {
  const key = "deal_statuses";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_DEAL_STATUSES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_DEAL_STATUSES.value, payload);
};

export const getPrepaymentTypes = payload => {
  const key = "prepayment_types";
  const items = localStorage.getItem(key);
  if (items) {
    return GET_PREPAYMENT_TYPES.createSuccess(JSON.parse(items));
  }

  return makeReadPayload(GET_PREPAYMENT_TYPES.value, payload);
};

export const getFundNames = payload => makeReadPayload(GET_FUND_NAMES.value, payload);

export const getUserCompanyContacts = payload => makeReadPayload(GET_USER_COMPANY_CONTACTS.value, payload);

export const getDealCompanyContacts = payload => makeReadPayload(GET_DEAL_COMPANY_CONTACTS.value, payload);

// Sagas
function* getLoanTypesSaga() {
  yield requestSaga(GET_LOAN_TYPES, "/getLoanTypes");
}

function* getLoanSeniorityTypesSaga() {
  yield requestSaga(GET_LOAN_SENIORITY_TYPES, "/getLoanSeniorityTypes");
}

function* getloanStatusesSaga() {
  yield requestSaga(GET_LOAN_STATUSES, "/getloanStatuses");
}

function* getLendersSaga() {
  yield requestSaga(GET_LENDERS, "/getLenders");
}

function* getBrokersSaga() {
  yield requestSaga(GET_BROKERS, "/getBrokers");
}

function* getSalesBrokersSaga() {
  yield requestSaga(GET_SALES_BROKERS, "/getSalesBrokers");
}

function* getDealStagesSaga() {
  yield requestSaga(GET_DEAL_STAGES, "/getDealStages");
}

function* getDealStatusesSaga() {
  yield requestSaga(GET_DEAL_STATUSES, "/getDealStatuses");
}

function* getPrepaymentTypesSaga() {
  yield requestSaga(GET_PREPAYMENT_TYPES, "/getPrepaymentTypes");
}

function* getFundNamesSaga(payload) {
  const { companyId } = payload;
  if (companyId) {
    yield requestSaga(GET_FUND_NAMES, `/fundNames?companyId=${companyId}`);
  } else {
    yield requestSaga(GET_FUND_NAMES, "/fundNames");
  }
}

function* getUserCompanyContactsSaga() {
  yield requestSaga(GET_USER_COMPANY_CONTACTS, "/userCompanyContacts");
}

function* getDealCompanyContactsSaga(payload) {
  const { dealId } = payload;
  yield requestSaga(GET_DEAL_COMPANY_CONTACTS, `/dealCompanyContacts/${dealId}`);
}

export function* enumeratedTypesSaga() {
  yield takeEvery(GET_LOAN_TYPES.value, getLoanTypesSaga);
  yield takeEvery(GET_LOAN_SENIORITY_TYPES.value, getLoanSeniorityTypesSaga);
  yield takeEvery(GET_LOAN_STATUSES.value, getloanStatusesSaga);
  yield takeEvery(GET_LENDERS.value, getLendersSaga);
  yield takeEvery(GET_BROKERS.value, getBrokersSaga);
  yield takeEvery(GET_SALES_BROKERS.value, getSalesBrokersSaga);
  yield takeEvery(GET_DEAL_STAGES.value, getDealStagesSaga);
  yield takeEvery(GET_DEAL_STATUSES.value, getDealStatusesSaga);
  yield takeEvery(GET_PREPAYMENT_TYPES.value, getPrepaymentTypesSaga);
  yield takeEvery(GET_FUND_NAMES.value, getFundNamesSaga);
  yield takeEvery(GET_USER_COMPANY_CONTACTS.value, getUserCompanyContactsSaga);
  yield takeEvery(GET_DEAL_COMPANY_CONTACTS.value, getDealCompanyContactsSaga);
}
